import React from 'react';
import {
    FileButton as FileButtonComponent,
    FileButtonProps
} from '@nesto/design-system';

export const FileButton = ({ ...props }: FileButtonProps) => (
    <FileButtonComponent {...props} />
);
